import { render, staticRenderFns } from "./SubHierachy.vue?vue&type=template&id=0201db89&scoped=true&"
import script from "./SubHierachy.vue?vue&type=script&lang=js&"
export * from "./SubHierachy.vue?vue&type=script&lang=js&"
import style0 from "./SubHierachy.vue?vue&type=style&index=0&id=0201db89&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0201db89",
  null
  
)

export default component.exports